import React from "react";
import { Box, Typography } from "@mui/material";

export interface DattoRmmGuideInnerProps {
  showGuideTitle?: boolean;
}

/** Datto's documented API activation flow, shared by all integration setup surfaces. */
export const DattoRmmGuideInner: React.FC<DattoRmmGuideInnerProps> = ({
  showGuideTitle = true,
}) => (
  <>
    {showGuideTitle ? (
      <Typography
        sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 15, color: "#1a1a1a", mb: 1.5 }}
      >
        Setup Guide — Datto RMM
      </Typography>
    ) : null}

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 14, color: "#1a1a1a", mb: 2 }}>
      Open your usual Datto RMM sign-in page and sign in with an <strong>Administrator</strong> account.
    </Typography>

    <Box component="ol" sx={{ m: 0, pl: 2.5, mb: 2, "& li": { mb: 0.75 } }}>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Go to <strong>Setup</strong> → <strong>Global Settings</strong> → <strong>Access Control</strong>.
        Turn on <strong>Enable API Access</strong>, click <strong>Save</strong>, then <strong>Confirm</strong>.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Go to <strong>Setup</strong> → <strong>Users</strong> and open the active user account Theo will use.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        In the <strong>API</strong> section, click <strong>Generate API Keys</strong>.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Choose an <strong>API security level</strong> with the permissions needed for the sites, devices, and actions Theo should access.
        Set the <strong>API Components level</strong> to include the components Theo should run.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Copy the <strong>API URL</strong> into the matching field in Theo. It appears after you generate the keys. Use your account&apos;s API address,
        such as <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 12 }}>https://vidal-api.centrastage.net</Typography>.
        Enter the base URL without an <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 12 }}>/api</Typography> or Swagger path.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Copy the <strong>API Key</strong> and <strong>API Secret Key</strong> into the matching fields in Theo before leaving
        the Datto user page.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Click <strong>Save user</strong> in Datto. Test the connection in Theo, then click <strong>Save</strong> after the test succeeds.
      </Typography>
    </Box>

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, mb: 2 }}>
      <strong>Important:</strong> The API Secret Key is hidden after you leave the Datto user page.
      Generating new keys invalidates the previous pair, so update any integrations using them.
    </Typography>
  </>
);
